/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import Loader from '../Loader';
const { useSelector, useDispatch } = Redux;

const { cartItems, sendCart } = Slices.cartSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { getClusterId } = Slices.configSlice;
const { selectCartId, selectCurrentCountry } = Slices.profileSlice;

export default function RefreshCartValues() {
  const cart = useSelector(cartItems);
  const cartId = useSelector(selectCartId);
  const dispatch = useDispatch();
  const cartValues = cart.length;
  const countOfItems = cart.reduce((a, { qty }) => a + qty, 0);
  const clusterId = useSelector(getClusterId);
  const [pageLoader, setPageLoader] = React.useState(false);
  const country = useSelector(selectCurrentCountry);
  const address = useSelector(selectDefaultAddress);

  let addressType = 'DELIVERY';
  let addressSubType = 'DELIVERY';

  if (Object.entries(address).length) {
    addressType = address.addressType;
    addressSubType = address.addressSubType;
  }
  const refreshCart = async () => {
    setPageLoader((prev) => true);
    const payload = {
      body: {
        addressSubType: addressSubType,
        addressType: addressType,
        addressId: address?.id || '',
        cartId: cartId,
        applySurprisePromo: false,
        clusterId: clusterId,
        items: cart,
        version: 'v20',
        orderType: addressType,
        storeId: address?.storeId,
      },
      headers: { country },
    };

    const valueofSend = await dispatch(sendCart(payload));
    if (valueofSend) {
      setPageLoader((prev) => false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  React.useEffect(() => {
    if (cartValues) {
      refreshCart();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countOfItems]);

  return pageLoader ? <Loader notToClear={true} /> : '';
}
